import React from "react";
import moment from "moment-timezone";

import { BONUS_TYPE_ID, FREQUENCY_ID, roles } from "../../../configs/constants";

export const columns = (onClickUpdatePremium, onClickHandlePremium, premiumList, roleId) => [
  {
    title: "Nom",
    dataIndex: "user_fullname",
    render: text => <a>{text}</a>
  },
  // {
  //   title: "Type de prime",
  //   dataIndex: "type_label"
  // },
  {
    title: "Montant",
    dataIndex: "amount",
    render: value => <div className="py-6">{value} €</div>
  },
  {
    title: "Date de saisie",
    dataIndex: "created_at",
    render: value => <div className="py-6">{value && moment(value).format("DD/MM/YYYY")}</div>
  },
  // {
  //   title: "Période",
  //   dataIndex: "period",
  //   render: (_, record = {}) => {
  //     const { start_date, end_date, type_id, _id, frequency_id } = record;
  //     if (type_id === BONUS_TYPE_ID.EXTRA || frequency_id === FREQUENCY_ID.MONTHLY)
  //       return <div key={_id}> {moment(start_date).format("MMMM")}</div>;
  //     return (
  //       <div key={_id}>
  //         {moment(start_date).format("MMMM")} - {moment(end_date).format("MMMM")}
  //       </div>
  //     );
  //   }
  // },
  {
    title: "Statut",
    dataIndex: "status",
    render: value => {
      const getStyle = () => {
        if (value) {
          if (value.id === 1) return "text-gray-500";
          if (value.id === 2) return "text-green-400";
          if (value.id === 3) return "text-red-400";
          if (value.id === 4) return "text-red-700";
        }
      };

      return <div className={`capitalize font-bold ${getStyle()}`}> {value && value.label}</div>;
    }
  },
  {
    title: "Traiter par",
    dataIndex: "created_by",
    render: value => <div>{value && value.user_fullname}</div>
  },
  {
    title: "Motif",
    dataIndex: "comment"
  }
  // {
  //   title: "Actions",
  //   dataIndex: "_id",
  //   render: premiumId => {
  //     const premiumItem = premiumList.find(item => item._id === premiumId);

  //     if (premiumItem.status.id === 1)
  //       return (
  //         <div className="flex flex-col">
  //           <a
  //             className="flex mt-2 cursor-pointer underline font-bold text-orange-400"
  //             onClick={() => {
  //               onClickUpdatePremium(premiumId);
  //             }}
  //           >
  //             Modifier
  //           </a>
  //           {(roleId === roles.ADMIN || roleId === roles.DIRECTOR) && (
  //             <a
  //               className="flex mt-2 cursor-pointer underline font-bold text-orange-400"
  //               onClick={() => {
  //                 onClickHandlePremium(premiumId);
  //               }}
  //             >
  //               A traiter
  //             </a>
  //           )}
  //         </div>
  //       );
  //   }
  // }
];

export const isBonusFormValid = data => {
  if (!data.user_email) throw new Error(`Il faut renseigner un email.`);
  if (!data.amount === null || !data.amount === undefined || data.amount < 0)
    throw new Error(`Le montant de la prime doit être supérieur ou égal à 0.`);
  if (!data.comment) throw new Error(`Un motif doit être renseigné.`);
};



// WEBPACK FOOTER //
// src/containers/admin/premium/Premium.utils.js